import * as _ from 'lodash';

export function formatFileSizeInBytes(bytes: string) {
    const bytesToKb = parseFloat(bytes) / 1000;

    return formatFileSize(bytesToKb.toString());
}

export function formatFileSize(kbSize: string): string {
    const kbSizeNumber = parseFloat(kbSize);
    const size = kbSizeNumber / 1000;

    if (_.isNaN(size)) {
        return undefined;
    }
    if (size > 500 && size <= 500000) {
        return `${(size / 1000).toFixed(2)} MB`;
    }
    if (size > 500000) {
        return `${(size / 1000000).toFixed(2)} GB`;
    }

    return `${size.toFixed(2)} kB`;
}
